import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class NgoService {
    constructor(private http: HttpClient) {
    }

    //INICIO NGO INVITATION
    invitationPending(): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/NgoInvitation/GetPending')
    }

    invitationAll(): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/NgoInvitation/GetAll')
    }

    changeSuggestID(email, newId): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'api/NgoInvitations/ChangeId?email=' + email + '&newId=' + newId, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    approveInvitation(email): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/NgoInvitation/approve?email=' + email, null, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    disapproveInvitation(email): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/NgoInvitation/disapprove?email=' + email, null, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
    //FIM NGO INVITATION

    getSupportedNgo(): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/Ngo/GetSupportedNgosByStore')
    }

    getContentToStore(seoUrl): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/Contents/GetContentToStore?seoUrl=' + seoUrl)
    }

    getImpactOfStore(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Ngo/GetImpactOfStore')
    }

    getCauses(): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/GetCauses')
    }

    getCausesCampaign(campaign): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/getCausesCampaigns?campaign=' + campaign)
    }

    getNgos(): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/GetSealNgos')
    }

    adminGetNgo(friendlyUrl): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/AdminGetNgo?ngoUrl=' + friendlyUrl)
    }

    getOctoberNgos(): any {
        return this.http.get(Configuration.apiUrl + 'api/Ngo/getOctoberNgos')
    }

    changeNgosOfStore(storeUrl, ngoUrlList): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/ChangeNgoOfStore', JSON.stringify({ storeUrl, ngoUrlList }), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    changeNgoByUser(storeUrl, ngoUrlList, causeUrl = null, isAdm = false): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Ngo/ChangeNgoByUser', JSON.stringify({ storeUrl, causeUrl, ngoUrlList, isAdm }), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }
}